const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
export const isIOS = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && typeof document !== "undefined" && "ontouchend" in document);
const isSafari = isIOS || (/Safari/.test(ua) && !/Chrome|CriOS|Android/.test(ua));

const MP4 = ["video/mp4;codecs=avc1,mp4a.40.2", "video/mp4;codecs=avc1", "video/mp4"];
const WEBM = ["video/webm;codecs=vp9,opus", "video/webm;codecs=vp8,opus", "video/webm"];
const CANDIDATES = isSafari ? [...MP4, ...WEBM] : [...WEBM, ...MP4];

const RES = { 1080: { width: { ideal: 1920 }, height: { ideal: 1080 } }, 720: { width: { ideal: 1280 }, height: { ideal: 720 } } };
const AUDIO = { echoCancellation: true, noiseSuppression: true, channelCount: 1 };

export async function openVideoStream(facing, maxRes) {
  const tiers = [1080, 720].filter((r) => r <= maxRes);
  const attempts = [
    ...tiers.map((r) => ({ video: { facingMode: facing, ...RES[r], frameRate: { ideal: 30, max: 30 } }, audio: AUDIO })),
    { video: { facingMode: facing }, audio: true },
  ];
  let lastErr;
  for (const c of attempts) {
    try { return await navigator.mediaDevices.getUserMedia(c); } catch (e) {
      lastErr = e;
      if (e?.name === "NotAllowedError") break;
    }
  }
  throw lastErr;
}

export const bitrateFor = (res) => {
  const p = res ? Math.min(res.w, res.h) : 720;
  return p >= 1080 ? 5_000_000 : p >= 720 ? 2_500_000 : 1_500_000;
};

export function createRecorder(stream, videoBitsPerSecond) {
  const supported = CANDIDATES.filter((m) => window.MediaRecorder?.isTypeSupported?.(m));
  for (const mimeType of [...supported, ""]) {
    try {
      const opts = { videoBitsPerSecond, audioBitsPerSecond: 128_000, ...(mimeType ? { mimeType } : {}) };
      return { rec: new MediaRecorder(stream, opts), mimeType };
    } catch {}
  }
  return { rec: new MediaRecorder(stream), mimeType: "" };
}
